import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Tile } from 'foundations-components/transitional/components/Tile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingComponent = () => {
  return /*#__PURE__*/_jsx(LoadingSpinner, {
    "data-test-id": "async-component-loading",
    grow: true,
    minHeight: 200
  });
};
LoadingComponent.displayName = 'AsyncComposeEditor#LoadingComponent';
const ErrorComponent = ({
  retry
}) => {
  return /*#__PURE__*/_jsx(Tile, {
    padding: "700",
    children: /*#__PURE__*/_jsxs(ErrorMessage, {
      title: I18n.text('composer-ui.code-splitting.error.title'),
      illustrationProps: {
        width: '100'
      },
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "composer-ui.code-splitting.error.message"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        size: "xs",
        onClick: retry,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "composer-ui.code-splitting.error.button"
        })
      })]
    })
  });
};
ErrorComponent.displayName = 'AsyncComposeEditor#ErrorComponent';
export const AsyncComposeEditor = Loadable({
  loader: () => import( /* webpackChunkName: "compose-editor" */'./ComposeEditor'),
  LoadingComponent,
  ErrorComponent
});